import React, { useState } from 'react';
import firebase, { firebaseAnalytics } from './Firebase';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as faHeartVuoto, faUser, faTrashAlt, faCalendar } from '@fortawesome/free-regular-svg-icons';
import { faHeart as faHeartPieno, faPen, faCheck, faTimes, faInfoCircle, faCalculator, faShareAlt, faPaperPlane, faLink } from '@fortawesome/free-solid-svg-icons';
import Player from "./Player";
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { Card, Button, Modal, ModalBody, ProgressBar, OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookMessengerIcon,
    FacebookMessengerShareButton,
    FacebookShareButton,
    TelegramIcon,
    TelegramShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton,
  } from "react-share";


export default function Recensione({ review, az, type, position }) {
    const [modify, setModify] = useState('');
    const [modifica, setModifica] = useState('');
    const [totale, setTotale] = useState(0);
    const [show, setShow] = useState(false);
    const [showShare, setShowShare] = useState(false);
    const [tipo, setTipo] = useState()
    const [azienda, setAzienda] = useState(az)
    const roundTo = require('round-to');
    const [comments, setComments] = useState([]);
    const [likes, setLikes] = useState([]);
    const [commento, setCommento] = useState('');
    const [iframeloading, setIframeloading] = useState(true);
    let history = useHistory();
    let url = "https://www.filosofinerba.it/recensioni/all"+"?id="+review.id

    const renderAromaIcon = aroma => {
        if (aroma === 'bosco' || aroma === 'legno' || aroma === 'critical') return '🌲';
        if (aroma === 'cacao' || aroma === 'cioccolato' || aroma === 'hash') return '🍫';
        if (aroma === 'mandorle' || aroma === 'castagne' || aroma === 'mandorla') return '🌰';
        if (aroma === 'menta' || aroma === 'tè' || aroma === 'verde') return '🍃';
        if (aroma === 'agrumi' || aroma === 'arancia' || aroma === 'mandarino') return '🍊';
        if (aroma === 'muschio' || aroma === "pino") return '🌳';
        if (aroma === 'profumato' || aroma === 'profumo') return '👃🏻';
        if (aroma === 'citrico' || aroma === 'limone') return '🍋';
        if (aroma === 'skunk' || aroma === 'pungente') return '🦨';
        if (aroma === 'uva' || aroma === 'mirtillo') return '🍇';
        if (aroma === 'gas' || aroma === 'diesel') return '⛽️';
        if (aroma === "vaniglia" || aroma === "gelato") return "🍨";
        if (aroma === "vernice" || aroma === "chimico") return "🧪";
        if (aroma === "arachidi" || aroma === "noccioline" || aroma === "nocciola") return "🥜";
        if (aroma === "frizzante") return "✨";
        if (aroma === 'incenso') return '🕯️';
        if (aroma === 'prugna') return '🍆';
        if (aroma === 'lavanda') return '🌿';
        if (aroma === 'ananas') return '🍍';
        if (aroma === 'tropicale') return '🥭';
        if (aroma === 'fresco') return '❄️';
        if (aroma === 'fiori') return '🌷';
        if (aroma === 'pesca') return '🍑';
        if (aroma === 'frutta') return '🍎';
        if (aroma === 'macedonia') return '🍏';
        if (aroma === 'miele') return '🍯';
        if (aroma === 'formaggio') return '🧀';
        if (aroma === 'spezie') return '🌶️';
        if (aroma === 'dolce') return '🍭';
        if (aroma === 'rose') return '🌹';
        if (aroma === 'caramello') return '🍮';
        if (aroma === 'birra') return '🍺';
        if (aroma === 'resina') return '🍭';
        if (aroma === 'panna') return '🍦';
        if (aroma === 'cipolla') return '🧅';
        if (aroma === 'fragola') return '🍓';
        if (aroma === 'ciliegia') return '🍒';
        if (aroma === 'cetriolo') return '🥒';
        if (aroma === 'anguria') return '🍉';
        if (aroma === 'pulito') return '🧼';
        if (aroma === "sigaro") return "🚬";
        if (aroma === "sughero") return "🍾";
        if (aroma === "metallo") return "⚙️";
        if (aroma === "cuoio") return "👜";
        if (aroma === 'altro') return '?';
    }

    const setRecensione = (recensione) => {
        //get likes
        firebase.firestore().collection('likes').doc(recensione.id).onSnapshot(likes => {
            var items = []
            if(likes.data() !== undefined ){
                items = likes.data().likes;
            }
            setLikes(items);
        });
        //get commenti
        firebase.firestore().collection('commenti').where('varietà', '==', recensione.id).onSnapshot(comment => {
            const items = [];
            comment.forEach(doc => items.push(doc.data()));
            setComments(items.reverse());
        });
        setTipo(recensione.tipo);
        setTimeout(() => {
            setTotale(recensione.tipo === 'Hash' ? roundTo((recensione.aspetto + recensione.fumata) / 2, 1) :
                roundTo((recensione.aspetto + recensione.fumata + recensione.odore + recensione.svapata) / 4, 1));
        }, 100);
        setShow(true);
    }

    const sendLike = () => {
        var newLikes = []
        if(likes !== undefined) {
            newLikes = likes
        }
        else 
        newLikes = []

        newLikes.push(firebase.auth().currentUser.email)
        
        firebase.firestore().collection('likes').doc(review.id)
        .set({
            likes: newLikes
        })
        .then(() => console.log("Like alla rece aggiunto!")).catch(error => console.error("Errore: ", error));
    };

    const removeLike = () => {
        var newLikes = likes
        for( var i = 0; i < newLikes.length; i++){
            if(newLikes[i] === firebase.auth().currentUser.email)
            newLikes.splice(i, 1);
        }
        firebase.firestore().collection('likes').doc(review.id).update({
            likes: newLikes
        })
        .then(() => console.log("Like alla rece rimosso!")).catch(error => console.error("Errore: ", error));
    };

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props} >
            <Link to={"/login"}>Accedi</Link> per mettere like.
        </Tooltip>
    );

    const renderTooltip2 = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            I valori di CBD dichiarati maggiori del 16% sono da dubitare.
            Scopri di più <a href="https://youtu.be/u5aAoEjnZ5Q?t=42" target="_blank">qui</a>.
        </Tooltip>
    );

    const onHideModal = () => {
        setShow(false);
        setTotale(0);
    }

    const onHideModalShare = () => {
        setShowShare(false);
    }

    const renderComments = comment => {
        return(
            <div className="commenti" style={{width: "80%"}}>
                <div className="row input--commenti" style={{padding: "1%", marginTop:"1%", marginInline: "5%"}}>
                    <div style={{width: "60%", textAlign: "right", alignSelf: "center"}}>
                        <text style={{ color: "lightgreen"}}><FontAwesomeIcon  icon={faUser} /> {comment.username} </text>
                    </div>
                    <div style={{width: "40%", textAlign: "center", alignSelf: "center"}}>
                        <text style={{ color: "rgb(216, 216, 218)"}}><FontAwesomeIcon icon={faCalendar}/> {comment.data}</text>
                    </div>
                </div>
                {/* Parte alta commento */}
                <hr style={{backgroundColor: "rgb(194, 194, 194)", marginInline: "4%", marginTop: "0%"}}/>
                <div className="row commenti--contenuti" >
                    {modify !== comment.id ? 
                        <>
                            {/* Contenuto commento */}
                            <div style={{width: "90%"}}>
                                {comment.commento}
                            </div>
                        </>
                         :
                        <>
                        {/* Modifica commento */}
                        <div className='invia-commento'>
                            <input value={modifica} className='input' type='text' onChange={event => setModifica(event.target.value)} />
                            <Button 
                                style={{marginLeft: "2%"}}
                                onClick={() => {
                                    setModify(null);
                                    firebase.firestore().collection('commenti').doc(comment.id).update({ commento: modifica });
                                }}>
                                    <FontAwesomeIcon color='white' icon={faCheck} />
                                </Button>
                            <Button 
                                style={{marginLeft: "2%"}}
                                variant="danger" 
                                onClick={() => 
                                    setModify(null)
                                }>
                                    <FontAwesomeIcon color='white' icon={faTimes} />
                                </Button>
                        </div>
                        </>
                    }
                </div>

                {/* Pulsanti modifica o elimina commento */}
                {(firebase.auth().currentUser != null && modify !== comment.id && comment.utente === firebase.auth().currentUser.email) ?
                        <div style={{ paddingBottom: '1%' }}>
                            <Button style={{marginRight: '1%' }} variant="info" 
                                onClick={() => { setModify(comment.id); setModifica(comment.commento) }}>
                                    <FontAwesomeIcon color='white' icon={faPen}/> Modifica
                            </Button>
                            <Button variant="danger" 
                                onClick={() => {
                                    if (window.confirm("Eliminare definitivamente la risposta?") === true) {
                                        firebase.firestore().collection('commenti').doc(comment.id).delete()
                                .then(() => console.log("Commento pubblicato!")).catch(error => console.error("Errore: ", error))}
                                    }
                                    }>
                                    <FontAwesomeIcon color='white' icon={faTrashAlt} />
                            </Button>
                        </div> 
                    : null}
            </div>
        )  
    }

    const sendComment = () => {
        const date = Date.now().toString();
        let today = new Date();
        firebase.firestore().collection('commenti').doc(date).set({
            utente: firebase.auth().currentUser.email,
            username: firebase.auth().currentUser.displayName,
            commento: commento,
            varietà: review.id,
            id: date,
            data: today.getDate() + "/" + parseInt(today.getMonth() + 1) + "/" + today.getFullYear()
        }).then(() => console.log("Commento pubblicato!")).catch(error => console.error("Errore: ", error));
        setCommento('');
    }

    const renderCard = recensione => (
        <Card className="box card__reviews" key={recensione.id}
            onClick={() => (
                setRecensione(recensione), 
                firebaseAnalytics.logEvent("review_visited", {
                    review_id: recensione.id
                }),
                firebaseAnalytics.setCurrentScreen("review_modal")
                )}>
            {recensione.anteprima !== undefined ? 
                <Card.Img className='card_img' variant="top" src={recensione.anteprima}/>
                :
                <Card.Img className='card_img' variant="top" src={"https://img.youtube.com/vi/"+recensione.video+"/mqdefault.jpg"}/>
            }
            <Card.Body style={{paddingTop: "5%", paddingBottom: "5%"}}>
                
                <Card.Text>
                
                    <div class="row" style={{ justifyContent: "space-evenly"}}>
                        <div style={{ height:"100%", width: "30%", flexDirection: "column", justifyContent: "space-between"}}>
                            <text style={{fontSize:12}}>Voto:</text> 
                            <br/>
                            <text style={{fontSize:25}}> 
                                {recensione.tipo === 'Hash' ?
                                roundTo((recensione.aspetto + recensione.fumata) / 2, 1) :
                                roundTo((recensione.aspetto + recensione.fumata + recensione.odore + recensione.svapata) / 4, 1)}
                            </text>
                            <br/>
                            <text style={{fontSize:12}}>Aromi:</text> 
                            <div>
                                {recensione.aromi === undefined ? null :
                                recensione.aromi.map(aroma => renderAromaIcon(aroma))}
                            </div>
                        </div>
                        <div style={{ width: "70%", alignSelf: "center"}}>
                            <text>{recensione.tipo === "Hash"? "🍫" : "🍁"}</text>
                            <br/>
                            <text style={{fontSize: 22}}>{recensione.varietà}</text>
                            <br/>
                            {azienda===undefined || azienda==="" ? null :<img src={az === undefined ? azienda.logo: az.logo} height="20px" width="20px"  style={{borderRadius: "100%", marginRight: "5px"}}/>}
                            <text style={{fontStyle: "italic"}}>{recensione.marca}</text>
                            </div> 
                    </div>
                    
                </Card.Text>
            </Card.Body>
        </Card>
    );

    const renderRow = (recensione, azienda) => {
        return <tbody key={recensione.id} style={{cursor: "pointer"}} onClick={() => {
            setRecensione(recensione);
            firebaseAnalytics.logEvent("rankings_review_visited", {
                review_id: recensione.id
            });
            firebaseAnalytics.setCurrentScreen("rankings_review_modal")
            }}>
            <tr>
                <td>{position}</td>
                <td><img src={azienda.logo} height="40px" width="40px"  style={{borderRadius: "100%"}}/></td>
                <td>{recensione.marca} </td>
                <td>{recensione.varietà}{recensione.terpenato}</td>
                <td>{recensione.tipo === 'Hash' ?
                    roundTo((recensione.aspetto + recensione.fumata) / 2, 1) :
                    roundTo((recensione.aspetto + recensione.fumata + recensione.odore + recensione.svapata) / 4, 1)
                    }
                </td>
            </tr>
        </tbody>
    }

    const renderEffetto = effetto => {
        if (effetto === "alto"){
            return (
                <>
                    <p className="effetto"  style={{backgroundColor: "inherit", justifyContent:"center", borderRadius: 10, fontSize: 15, color:"white"}}>Basso</p>
                    <p className="effetto"  style={{backgroundColor: "inherit", justifyContent:"center", borderRadius: 10, fontSize: 15, color:"white"}}>Medio</p>
                    <p className="effetto"  style={{backgroundColor: "dodgerblue", justifyContent:"center", borderRadius: 10, fontSize: 15, color:"black" }}>Alto</p>
                </>)
        }
        else if (effetto === "medio"){
            return (
                <>
                    <p className="effetto"  style={{backgroundColor: "inherit", justifyContent:"center", borderRadius: 10, fontSize: 15, color:"white"}}>Basso</p>
                    <p className="effetto"  style={{backgroundColor: "limegreen", justifyContent:"center", borderRadius: 10, fontSize: 15, color:"black"}}>Medio</p>
                    <p className="effetto"  style={{backgroundColor: "inherit", justifyContent:"center", borderRadius: 10, fontSize: 15, color:"white" }}>Alto</p>
                </>)
        }
        else if (effetto === "basso"){
            return (
                <>
                    <p className="effetto"  style={{backgroundColor: "orange", justifyContent:"center", borderRadius: 10, fontSize: 15, color:"black"}}>Basso</p>
                    <p className="effetto"  style={{backgroundColor: "inherit", justifyContent:"center", borderRadius: 10, fontSize: 15, color:"white"}}>Medio</p>
                    <p className="effetto"  style={{backgroundColor: "inherit", justifyContent:"center", borderRadius: 10, fontSize: 15, color:"white" }}>Alto</p>
                </>)
        }
    }

    const likeButton = () => {
        if(likes && firebase.auth().currentUser !== null){
            if (likes.includes(firebase.auth().currentUser.email)) {
                return <FontAwesomeIcon color={"red"} style={{cursor: "pointer"}}  icon={faHeartPieno} size='2x' onClick={() => {removeLike(review.id)}}/>
            }
            else {
                return <FontAwesomeIcon color={"white"} style={{cursor: "pointer"}}  icon={faHeartVuoto} size='2x'  onClick={() => {sendLike(review.id)}}/>
            }
        }
        else if(likes && firebase.auth().currentUser === null){
            return <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 1000 }}
                        overlay={renderTooltip()}
                    >
                    <FontAwesomeIcon color={"white"} style={{cursor: "pointer"}}  icon={faHeartVuoto} size='2x'/>
                </OverlayTrigger>
        }
        
        if(!likes){
            if(firebase.auth().currentUser === null){
                return  <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 1000 }}
                                overlay={renderTooltip()}
                            >
                            <FontAwesomeIcon color={"white"} style={{cursor: "pointer"}}  icon={faHeartVuoto} size='2x'/>
                        </OverlayTrigger>
            }
            else {
                return <FontAwesomeIcon color={"white"} style={{cursor: "pointer"}}  icon={faHeartVuoto} size='2x'  onClick={() => {sendLike(review.id)}}/>
            }
        }
        else{ 
            if(!likes.includes(firebase.auth().currentUser.email)){
                return  <FontAwesomeIcon color={"white"} style={{cursor: "pointer"}} icon={faHeartPieno} size='2x'  onClick={() => {sendLike(review.id)}}/>
            }
            else {
                return <FontAwesomeIcon color={"white"} style={{cursor: "pointer"}}  icon={faHeartVuoto} size='2x'  onClick={() => {removeLike(review.id)}}/>
            }
        }
    }

    return (
        <>
            {type === "row" ? renderRow(review, az) : renderCard(review, az)}
            
            <Modal size='lg' show={show} centered onHide={() => onHideModal()} >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body style={{ color: '#2c2c32' }}>
                    <div class="row" style={{justifyContent: "center", marginTop: "-4%", marginBottom: "4%"}}>
                        <p className=" modal--nome--varieta">{review.varietà}</p>
                        <text style={{alignSelf: "center"}}>{tipo === "Hash"? "🍫" : "🍁"}</text>
                              <p className="modal--nome--varieta modal--nome--azienda" style={{alignSelf: "self-end", marginLeft: "10px"}}>
                                    <text style={{ cursor: "pointer"}} onClick={() => {onHideModal(); history.push("/aziende/"+review.marca)}}>{review.marca}</text>
                                    {azienda===undefined || azienda==="" ? null :
                                        <img src={az === undefined ? azienda.logo: az.logo} height="35px" width="35px"  style={{borderRadius: "100%", marginLeft: "10px", boxShadow: "4px 4px 10px black", cursor: "pointer"}} onClick={() => {onHideModal(); history.push("/aziende/"+review.marca)}}/>
                                    }                       
                                </p>
                    </div>
                    
                    <div className='row--modal row--modal_736'>
                        <div className='col col-50s modal--voti_736'>
                        <div className='riga'>
                                <br/>
                                <p className="voti">Aspetto👀<ProgressBar className='progress '  min={0} max={10} now={review.aspetto} label={review.aspetto} /></p>
                                {tipo !== 'Hash' ? <>
                                    <p className="voti">Odore👃🏼<ProgressBar className='progress'  min={0} max={10} now={review.odore} label={review.odore} /></p>
                                    <p className="voti">Svapata💨<ProgressBar className='progress'  min={0} max={10} now={review.svapata} label={review.svapata} /></p>
                                </> : null}
                                <p className="voti">Fumat{tipo ==="Erba" ? "a" : "o"}🚬<ProgressBar className='progress'  min={0} max={10} now={review.fumata} label={review.fumata} /></p>
                                <p className="voti">Aromi👅 
                                    <p className="aromi">
                                        {review.aromi === undefined ? 
                                            <div style={{textAlign: "center", paddingInline: "5%" }}>
                                                <text>Non specificati</text>
                                            </div> 
                                            : review.aromi.map(aroma => 
                                            <div style={{textAlign: "center", paddingInline: "3%"}}>
                                                <text>{renderAromaIcon(aroma)}</text>
                                                <br/>
                                                <text style={{ fontSize: "medium" }}>{aroma}</text>
                                            </div>
                                        )}
                                    </p>
                                </p>
                                <p className="voti"><text>Media <FontAwesomeIcon icon={faCalculator}/></text><ProgressBar className='progress'  min={0} max={10} now={totale} label={review.tipo >= 'Hash' ? roundTo((review.aspetto + review.fumata) / 2, 1) :
                                    roundTo((review.aspetto + review.fumata + review.odore + review.svapata) / 4, 1)} /></p>
                                {review.effetto === undefined ? null :
                                    <>
                                    <hr style={{backgroundColor: "rgb(194, 194, 194)", marginInline: "4%"}}/>
                                    <p class="voti" >
                                    <p  style={{color: "white", fontSize: 15, flexFlow:"column" }}>Effetto <br/> percepito:</p>
                                    <div class="row" style={{width: "60%"}}>
                                        {renderEffetto(review.effetto)}
                                    </div>
                                    </p>
                                    </>
                                }
                                {review.valori === undefined ? null :
                                    
                                    <p class="voti" >
                                        <p  style={{color: "white", fontSize: 15 }}>Percentuali <br/> dichiarate:</p>
                                        <OverlayTrigger
                                                placement="top"
                                                delay={{ show: 250, hide: 1000 }}
                                                overlay={renderTooltip2()}
                                            >
                                            <FontAwesomeIcon color='white' style={{cursor: "pointer"}}  icon={faInfoCircle} />
                                        </OverlayTrigger>
                                        <div style={{width: "50%", alignItems: "center", justifyContent: "left"}} >
                                            <p className="valori">~ {review.valori.cbd}% CBD</p>
                                            <p className="valori">~ {review.valori.thc}% THC</p>
                                        </div>
                                    </p>
                                }
                                <br/>
                            </div>
                            {/* LIKE BUTTON */}
                            <div class="row" style={{justifyContent:"center", marginTop: "6%", alignItems: "center"}}>
                               
                                <div className="like--button">
                                    {likeButton()}
                                </div>
                                    
                                <div style={{ color: 'white', paddingLeft: "2%",paddingTop: "1%" }}>
                                        {likes ? likes.length: 0}
                                </div>
                                <Button 
                                    onClick={()=> {firebaseAnalytics.logEvent("button_acquista_pressed"); window.open(azienda.sito, "_blank")}}
                                    variant="secondary" 
                                    style={{ width:"50%", marginLeft: "5%", backgroundColor: "#2c2c32", borderColor:"white", boxShadow: "white" }}>
                                        <text style={{paddingRight: "5%"}}>Acquista</text>
                                        <FaExternalLinkAlt color="white" />
                                </Button>
                                <FontAwesomeIcon icon={faShareAlt} size='2x' color='white' style={{ marginLeft: "10px", cursor: "pointer"}} onClick={() => setShowShare(true)}/>
                            </div>
                            <br/>
                        </div>
                        <div class="col">
                            <div>
                            { review.video ?
                                (review.video.includes("theweedtube")?
                                    <>
                                        {iframeloading && 
                                            <h5 style={{ color: 'white', textAlign: "center" }}>Loading <Spinner animation="grow" /></h5>
                                        }
                                        <iframe width="100%" height="350px" 
                                            src={review.video} 
                                            title="Video recensione" 
                                            frameborder="0" 
                                            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                            allowfullscreen 
                                            onLoad={() => setIframeloading(false)} 
                                        />
                                    </>
                                    :
                                    <Player videoId={review.video}/>
                                ): null
                            }
                            </div>
                    </div>
                    </div>
                    <div style={{ textAlign: "center" }}>
                        {firebase.auth().currentUser == null ? 
                            <div className="per--commenti">
                                <Link to="/login" style={{color: "red", textDecoration: "underline" }}> Accedi</Link> per lasciare un commento
                            </div> :
                            <div className="per-commentare" style={{width: "100%", paddingTop: "2%", paddingBottom: "2%"}}>
                                <input value={commento} className='input' type='text' placeholder='Lascia un commento...' onChange={event => setCommento(event.target.value)} />
                                <Button 
                                    className="invia-commento" 
                                    style={{ backgroundColor: "#2c2c32"  }} 
                                    variant="secondary" 
                                    disabled={commento === '' ? true : false} 
                                    onClick={() => sendComment()}>
                                        <FontAwesomeIcon icon={faPaperPlane}/>
                                </Button>
                            </div>}
                        {comments.length === 0 && 
                            <text style={{color: "white", justifyContent: "center"}}>Ancora nessun commento</text>}
                        {comments.map(data => renderComments(data))}
                    </div>
                </Modal.Body>
            </Modal>

            <Modal size="md" show={showShare} centered onHide={() => onHideModalShare()} >
            <ModalBody>
                <div className="row" style={{justifyContent: "space-evenly"}}>
                    <div style={{color: 'white', alignSelf: "center", cursor: "pointer"}} onClick={() => {navigator.clipboard.writeText(url); onHideModalShare()}}>
                        <FontAwesomeIcon icon={faLink} size="2x" />
                        <text style={{verticalAlign: "super", marginLeft: "2px"}}>Link</text>
                    </div>
                    <div style={{color: 'white'}}>
                        <EmailShareButton url= {url}>
                            <EmailIcon round={true} size={40} />
                            Email
                        </EmailShareButton>
                    </div>
                    <div style={{color: 'white'}}>
                        <WhatsappShareButton url= {url} >
                            <WhatsappIcon round={true} size={40} />
                            Whatsapp
                        </WhatsappShareButton>
                    </div>
                    <div style={{color: 'white'}}>
                        <TelegramShareButton url= {url} >
                            <TelegramIcon round={true} size={40} />
                            Telegram
                        </TelegramShareButton>
                    </div>
                    <div style={{color: 'white'}}>
                        <FacebookShareButton url= {url}>
                            <FacebookIcon round={true} size={40}/>
                            Facebook
                        </FacebookShareButton>
                    </div>
                    <div style={{color: 'white'}}>
                        <TwitterShareButton url= {url} >
                            <TwitterIcon round={true} size={40}/>
                            Twitter
                        </TwitterShareButton>
                    </div>
                    <div style={{color: 'white'}}>
                        <FacebookMessengerShareButton url= {url} >
                            <FacebookMessengerIcon round={true} size={40}/>
                            Messenger
                        </FacebookMessengerShareButton>
                    </div>
                </div>
            </ModalBody>
            </Modal>
        </>
    );
}